import { render, staticRenderFns } from "./StudiesResult.vue?vue&type=template&id=686e4b92&"
import script from "./StudiesResult.vue?vue&type=script&lang=js&"
export * from "./StudiesResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports